import { DateTime } from "luxon";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface StatFilters {
  location_uuid: string;
  period_type: string;
  start_date: string;
  end_date: string;
}

const initialState: StatFilters = {
  location_uuid: "all_sites",
  period_type: "this_week",
  start_date: DateTime.now().startOf("week").toISO()!,
  end_date: DateTime.now().toISO()!,
};

export const practiceStatFilterSlice = createSlice({
  name: "practiceStatFilters",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<StatFilters>>) => {
      if (action.payload.location_uuid) {
        state.location_uuid = action.payload.location_uuid;
      }

      if (
        action.payload.start_date &&
        action.payload.end_date &&
        action.payload.period_type
      ) {
        state.period_type = action.payload.period_type;
        state.start_date = action.payload.start_date;
        state.end_date = action.payload.end_date;
      }
    },

    clearFilters: (state) => {
      state = {
        location_uuid: "all_sites",
        period_type: "all_week",
        start_date: DateTime.now().startOf("week").toISO()!,
        end_date: DateTime.now().toISO()!,
      };
    },
  },
});

export const { setFilters, clearFilters } = practiceStatFilterSlice.actions;

export default practiceStatFilterSlice.reducer;
